import { z } from 'zod'
import { flightInformationSchema } from './flight-information'

export const benefitAndVoucherManagementGetMyItineraryListSchema = z.object({
  /** 訂位代號 */
  pnr: z.string(),
  /** 航班資訊 */
  flightInformation: z.array(flightInformationSchema),
  /** 機票號碼 */
  ticketNumber: z.string().optional(),
  /** 航段 */
  flightSegment: z.array(z.string()),
  /** 是否有使用禮遇項目 */
  usedCourtesy: z.boolean(),
  /** 出發日期 */
  departureTime: z.string(),
  /** 艙等 */
  rbd: z.string(),
  /** 禮遇安排 */
  courtesyArrangement: z.boolean(),
  /** 排除行程 */
  excludeItinerary: z.boolean(),
  /** 可否顯示排除行程 */
  showExcludeItinerary: z.boolean()
})

export interface BenefitAndVoucherManagementGetMyItineraryList
  extends z.infer<typeof benefitAndVoucherManagementGetMyItineraryListSchema> {}
